import { render } from "./Articles.vue?vue&type=template&id=945291ac&ts=true"
import script from "./Articles.vue?vue&type=script&lang=ts"
export * from "./Articles.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\development\\source\\repositories\\Koncepta\\Core.Services\\Core.WebApp\\admin-ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__